import { render, staticRenderFns } from "./ProductStockModal.vue?vue&type=template&id=141fdcbf&"
import script from "./ProductStockModal.vue?vue&type=script&lang=js&"
export * from "./ProductStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141fdcbf')) {
      api.createRecord('141fdcbf', component.options)
    } else {
      api.reload('141fdcbf', component.options)
    }
    module.hot.accept("./ProductStockModal.vue?vue&type=template&id=141fdcbf&", function () {
      api.rerender('141fdcbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/stock/modules/ProductStockModal.vue"
export default component.exports